$('.partner-slider .logo-bar').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  dots: false,
  autoplaySpeed: 1500,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    }
  ]
});

var product_name = $('.product_name').text();
console.log(product_name);
// To popup form on product page
$('.price_quote').on('click',function(e){
  e.preventDefault();
  $('.g-form-container').fadeIn(700).addClass('popup-active'); 
  $('body').addClass('body-overflow');
  $('#60191-text-2').val(product_name);
  $('#60191-text-2').addClass('pointer-event');
});

var product = $('.js-product-title').text();
console.log(product)
// To popup form on quick view
$(document).on('click','.custom_quote_second', function(e){
  e.preventDefault();
  $('.g-form-container-quick').fadeIn(700).addClass('popup-active'); 
  $('body').addClass('body-overflow');
  $('#60191-text-2').addClass('pointer-event')
});


$(document).on('click','.g-form .close_popup', function(e){
  e.preventDefault();
  console.log("close");
  $('.g-form-container').fadeOut(700).removeClass('popup-active d-flex');
  $('body').removeClass('body-overflow');
});
$(document).on('click','.g-form-quick .close_popup-quick', function(e){
  e.preventDefault();
  console.log("close");
  $('.g-form-container-quick').fadeOut(700).removeClass('popup-active d-flex');
  $('body').removeClass('body-overflow');
});

document.querySelectorAll(".team-member__details p,.page .content.page h3").forEach(el => el.textContent.trim() === "" && el.parentNode.removeChild(el));


$(document).on('click','.g-form-container .close_popup,.close_popup-quick', function(){
    setTimeout(function() {
      if($(".g-form-container .message.success,.g-form-container-quick .message.success").is(":visible")){
       location.reload();   
      }
    })
});
$(document).on('click','.g-form-container .action.submit', function(){
    setTimeout(function() {
      if($(".g-form-container .message.success").is(":visible")){
       location.reload();   
      }
    })
});
$(document).on('click','.g-form-container-quick .action.submit', function(){
    setTimeout(function() {
      if($(".g-form-container-quick .message.success").is(":visible")){
       location.reload();   
      }
    })
});

$(document).ready(function(){ 
    $('.tab li').click(function(){  
      $(".tabs .product-list").removeClass('tab-active');
      $(".tabs .product-list[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
      $(".tab li").removeClass('active-a');
      $(this).addClass('active-a');
      // $('.splidejs').slick('setPosition');
     });

    //  jQuery(function() {
    //     var a = $(".collection_description");
    //     a.each(function() {
    //         var a = $(this).text();
    //         a.length < 360 || $(this).html(a.slice(0, 360) + '<span class="more">... <br></span><a href="#" class="more des_collection_show_more">Show More</a><span class="less">' + a.slice(360, a.length) + '<br><a href="#" class="des_collection_show_less">Show Less</a></span>')
    //     }), $("a.des_collection_show_more", a).click(function(a) {
    //         a.preventDefault(), $(this).parent(".collection_description").addClass("collection_description_more")
    //     }), $("a.des_collection_show_less", a).click(function(a) {
    //         a.preventDefault(), $(this).parent().parent(".collection_description").removeClass("collection_description_more")
    //     }), document.querySelectorAll("div.g-recaptcha").forEach(a => {
    //         a.parentElement.addEventListener("submit", function(a) {
    //             "" === grecaptcha.getResponse() && (a.preventDefault(), alert("Please check the recaptcha"))
    //         }, !1)
    //     })
    // })
});